<template>
  <section>
    <div v-for="child in getChildStarProgress" :key="child.child">
      <div class="d-flex aling-items-center">
        <p class="mr-2">{{ child.child_name }} stars</p>
        <question-popup
          v-if="childPopups.star"
          :popoverKey="`star-skill-${child.child}`"
          :title="childPopups.star.title"
          :description="childPopups.star.information"
          class="text-main2"
        />
      </div>

      <stars-bar customClass="custom-stars-bar" :data="getStarsData(child)" />
      <line-chart
        class="mb-5"
        :ref="`chartChild${child.child}`"
        :series="calculeSerie(child)"
        :customOptions="customOptions"
        @change-data="handlerChangeDataChart($event, child.child)"
      />
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import StarsBar from '@/components/general/starsBar/starsBar.vue';
import QuestionPopup from '@/components/general/QuestionPopup.vue';
import lineChart from '@/components/apexCharts/LineChart';
import mixinNotificationToast from '@/mixins/notificationToast.mixin.js';

export default {
  components: {
    lineChart,
    StarsBar,
    QuestionPopup,
  },
  mixins: [mixinNotificationToast],
  data() {
    return {
      options: [
        { value: null, text: 'All' },
        { value: 1, text: 'Total' },
        { value: 2, text: 'Morning' },
        { value: 3, text: 'Afternoon' },
        { value: 4, text: 'Evening' },
        { value: 5, text: 'Anytime' },
      ],
      customOptions: {
        tooltip: {
          y: {
            formatter: function(val) {
              return Math.abs(Math.ceil(val)) + '%';
            },
          },
        },
        yaxis: {
          min: 0,
          max: 100,
          title: {
            text: 'Percentage',
          },
          labels: {
            formatter: function(val) {
              return Math.abs(Math.ceil(val)) + '%';
            },
          },
        },
        xaxis: {
          type: 'datetime',
        },
        noData: {
          text: 'Loading data...',
        },
      },
    };
  },
  methods: {
    ...mapActions('progress', ['FetchChildrenStarProgress', 'fetchStarsProgressByChildId']),
    dateDisabled(ymd, date) {
      let weekAgo = new Date();
      weekAgo.setDate(weekAgo.getDate());
      return date > weekAgo;
    },
    calculeSerie(data) {
      let serieAll = [];
      let serieMorning = [];
      let serieAfternoon = [];
      let serieEvening = [];
      let serieAnyTime = [];
      data.stars_progress.map((element) => {
        serieMorning.push({
          x: element.date,
          y: element[1].percentage * 100,
        });
        serieAfternoon.push({
          x: element.date,
          y: element[2].percentage * 100,
        });
        serieEvening.push({
          x: element.date,
          y: element[3].percentage * 100,
        });
        serieAnyTime.push({
          x: element.date,
          y: element[4].percentage * 100,
        });
        serieAll.push({
          x: element.date,
          y: element.percentage * 100,
        });
      });
      return [
        {
          name: 'morning',
          data: serieMorning,
        },
        {
          name: 'afternoon',
          data: serieAfternoon,
        },
        {
          name: 'evening',
          data: serieEvening,
        },
        {
          name: 'anytime',
          data: serieAnyTime,
        },
        {
          name: 'all',
          data: serieAll,
        },
      ];
    },
    getStarsData(data) {
      return [
        { text: `Daily Reward Stars`, stars: data.today_available, display: true },
        { text: `Today Total Stars`, stars: data.today_stars, display: true },
        { text: 'Big Reward Stars', stars: data.total_available, display: true },
        { text: `Grand Total`, stars: data.total_stars, display: true },
      ];
    },
    childCurrentData(childId) {
      const currentData = this.getChildStarProgressById(childId);

      return {
        currentChartData: this.calculeSerie(currentData),
        mostCurrentDate: currentData.stars_progress[0].date,
        oldestDate: currentData.stars_progress[currentData.stars_progress.length - 1].date,
      };
    },
    calculateDate(multiplier, date) {
      const ONEDAY = 24 * 3600 * 1000;
      const currentDate = new Date(date);
      const newDate = new Date(currentDate.getTime() + multiplier * ONEDAY);

      return [newDate.getUTCFullYear(), newDate.getUTCMonth() + 1, newDate.getUTCDate()]
        .map((value) => (value < 10 ? '0' + value : value))
        .join('-');
    },
    async handlerChangeDataChart(direction, childId) {
      const chart = this.$refs[`chartChild${childId}`][0];

      try {
        const { mostCurrentDate, oldestDate } = this.childCurrentData(childId);
        const startDate =
          direction === 1
            ? this.calculateDate(14, mostCurrentDate)
            : this.calculateDate(-1, oldestDate);

        if (new Date(startDate).getTime() > Date.now())
          throw {
            info: 'You are trying to see dates that have not yet occurred',
            variant: 'warning',
          };

        chart.updateData([]);
        await this.fetchStarsProgressByChildId({ parentId: this.getUserId, childId, startDate });
      } catch (error) {
        const message = error.info || 'Could not update the chart. Try again';
        const variant = error.variant || 'danger';

        chart.updateData(this.childCurrentData(childId).currentChartData);
        this.notificationToast({ message, variant, title: 'Chart' });
      }
    },
  },
  computed: {
    ...mapGetters('progress', ['getChildStarProgress', 'childPopups', 'getChildStarProgressById']),
    ...mapGetters('user', ['getUserId']),
  },
};
</script>
